import _mergeJSXProps from './node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.mjs';

var BagBinocularsBgIcon = {
  name: 'BagBinocularsBgIcon',
  props: {},
  functional: true,
  render(h, ctx) {
    const attrs = ctx.data.attrs || {};
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      "attrs": {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 129 89"
      },
      "class": "c-ficon c-ficon--bag-binoculars-bg"
    }, ctx.data]), [h("path", {
      "attrs": {
        "d": "m.4.1 16.4 88.2 110.6-67.8L.4.1Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M20.8 63.3s6.3-18 7.3-22.7l5.5-25.2s6.3-.1 10-1.3c0 0 10.2.3 14.6.8s25.7 0 25.7 0-4.7 28-4.9 33c-.2 5-1.9 18.6-1.9 18.6s-33.4 1.7-39 2.3c-5.6.7-9.3 0-9.3 0l-8-5.5Z",
        "fill": "#fff"
      }
    }), h("path", {
      "attrs": {
        "d": "m28.8 68.8-8-5.5s2.5-7.4 5-15.2c2.3-7.9 7.6-29.2 7.6-32.3 0 0 8.3-.3 11-1.8 0 0-2.3 19.7-4.6 27.2s-5.6 17-7.6 21l-3.4 6.6Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M68.5 50.2a146.5 146.5 0 0 0-2.8-4.2v-3.7a.5.5 0 0 0-.3-.5l-.9-.4c-.3-.1-.7 0-.8.3a10.8 10.8 0 0 0-.2 1.4l-.3-.6c-.6-.7-1.1-1.5-1.8-2.1-.7-.8-1.6-.8-2.5-.4-4.3 2-8.1 5.3-11 9a.6.6 0 0 0 0 .8 5 5 0 0 0 2.8 1c-.5 2-.8 4-.8 5.9 0 1.2.9 1.3 1.8 1.3h.2l1.4.2a35.4 35.4 0 0 1 .9-4.8 1.9 1.9 0 0 1-.3-.1c-.6-.3-.8-1-.8-1.5 0-.6 0-1.2.2-1.8l.1-.3.5-2.2c.1-.4.9-.2.8.2l-.5 2v.4l-.2.4a.4.4 0 0 1 0 .2.2.2 0 0 0 .1.1.6.6 0 0 0 .2.2 1 1 0 0 0 .3.1h.2l.8-3.5c.2-.5 1-.3.8.2a71.7 71.7 0 0 0-.6 2.6l-.2.8a3.4 3.4 0 0 0 1-.2l.9-3.3c0-.5.8-.3.7.2l-.4 1.5-.6 2a5.2 5.2 0 0 1-.6 1.6 1 1 0 0 1-.8.4.9.9 0 0 1-.1 0 .4.4 0 0 1-.1 0h-.3a52.1 52.1 0 0 1-.6 4.8l1.4.2 3.4.1A40.1 40.1 0 0 1 60 56h-.2a2 2 0 0 1-.9-.1.6.6 0 0 1-.3-.4.4.4 0 0 1-.1-.4 13.8 13.8 0 0 1 .4-1.8 14.5 14.5 0 0 1 3-5.5c.2-.5.9-.4.8 0a.4.4 0 0 1 0 .2c0 1 0 2-.2 2.9a76 76 0 0 1-.6 4.8 58.8 58.8 0 0 1-.5 2.8 5 5 0 0 0 2.3-.5c.9-.5 1-1.5 1.2-2.4a23.9 23.9 0 0 1 0-.4l.8-3.8a6.5 6.5 0 0 0 2.5-.4.6.6 0 0 0 .3-.8Zm-19.4-1a1.6 1.6 0 0 0 0-.1l.1.1h-.1Zm6.4-3.6Zm7-2 .2.1.7 1 .1.2.2.2a11.3 11.3 0 0 1-1.1-1.5Zm2 .8v.1-.2a.5.5 0 0 1 0 .1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M33.3 16.5c1.6.3 3.4 0 5-.1 2.3-.3 4.5-.9 6.7-1.4 1.5-.3.9-2.5-.6-2.2-2 .4-4 1-6.1 1.2a40.6 40.6 0 0 1-3.6.2H34c-1.5-.2-2.1 2-.7 2.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M45 15.2a219.8 219.8 0 0 0 39 .8c1.4 0 1.4-2.4 0-2.3a219.8 219.8 0 0 1-39-.8c-1.5-.2-1.5 2.1 0 2.3Zm-12.7 0A308.2 308.2 0 0 1 25.9 44c-.4 1.4 1.8 2 2.2.6a309.2 309.2 0 0 0 6.4-28.7c.3-1.5-2-2.1-2.2-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m25.6 44.5-6 18.5c-.4 1.5 1.8 2 2.3.6l6-18.5c.5-1.4-1.8-2-2.3-.6Zm57.2-30c-1.8 12.6-3.6 25.1-5.6 37.7-.3 1.4 2 2 2.2.6 2-12.5 3.8-25 5.7-37.6.2-1.5-2-2.1-2.3-.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M77.1 52.7a116.9 116.9 0 0 1-1.5 13.2c-.2 1.5 2 2.2 2.3.7a122.7 122.7 0 0 0 1.5-13.9c.1-1.5-2.2-1.5-2.3 0Zm-57 11.6c2.3 2 4.6 3.8 7.3 5.4 1.3.7 2.5-1.3 1.2-2a55 55 0 0 1-7-5c-1-1-2.7.6-1.6 1.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M28 70a1501.2 1501.2 0 0 0 25-.4c8-.2 16.2 0 24-2 1.5-.4.8-2.6-.6-2.3-7.7 2-15.8 1.8-23.7 2l-24.6.4c-1.5 0-1.5 2.3 0 2.3Zm32.3-54.9a29.8 29.8 0 0 1 2.5-6c.7-1.4-1.4-2.6-2-1.2a32.8 32.8 0 0 0-2.7 6.6c-.4 1.4 1.8 2 2.2.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M62.2 9.6h6l6.4.4c1.5.2 1.4-2.2 0-2.3l-6.3-.4h-6.1c-1.5.1-1.5 2.4 0 2.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M73.6 8.7a94.7 94.7 0 0 1-2 6.2c-.5 1.4 1.8 2 2.3.6a95.2 95.2 0 0 0 2-6.2c.4-1.4-1.8-2-2.3-.6Zm-8 6.1a14.8 14.8 0 0 0 .2-3c0-.6-.6-1-1.2-1-.7 0-1.2.4-1.2 1a11.8 11.8 0 0 1 0 2.4c-.2.6 0 1.3.7 1.4.6.2 1.4-.2 1.5-.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M64.4 10.5c-4-.9-7.9-1.6-11.8-2.2-1.5-.2-2.1 2-.7 2.3 4 .5 8 1.3 11.9 2.2 1.4.3 2-2 .6-2.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M51 9.5a18.6 18.6 0 0 0-1 3.9c-.2 1.5 2 2 2.3.6a18.5 18.5 0 0 1 1-3.9c.3-.6-.2-1.3-.8-1.4-.6-.2-1.2.2-1.4.8Zm-7.6 5.8a53.7 53.7 0 0 1-1 9.8c-.2 1 1.3 1.4 1.5.4A56.1 56.1 0 0 0 45 15.3c0-1-1.5-1-1.6 0Zm-14 54A90.3 90.3 0 0 0 36 55c.4-1-1.1-1.4-1.5-.4a87.5 87.5 0 0 1-6.4 13.8c-.5 1 .8 1.7 1.3.8Zm10.3-24.8 2-7c.3-1-1.2-1.4-1.5-.5l-2 7c-.3 1 1.2 1.4 1.5.5Zm5 24-2.6 11c-.4 1.4 1.8 2 2 .6l2.7-11c.4-1.4-1.8-2-2.1-.6Zm14.4.5-2.4 10.2c-.3 1.4 1.9 2 2.1.6l2.4-10.3c.4-1.3-1.7-2-2-.5Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M50.2 23.6a7.8 7.8 0 0 0 4.3 5.2.5.5 0 0 0 .7-.2.5.5 0 0 0-.2-.6 6.9 6.9 0 0 1-3.8-4.7c-.2-.6-1.1-.4-1 .3Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m51.6 24.8.2-.1c-.1 0 0 0 0 0v-.1h.4c-.1 0 0 0 0 0a13.3 13.3 0 0 0 .2.2 3 3 0 0 1 .2.3c0-.1 0 0 0 0a1 1 0 0 1 0 .1s0 .2 0 0a1 1 0 0 1 0 .3.6.6 0 0 1 0 .3c0-.1 0 0 0 0a1 1 0 0 1-.1.1l-.1.1a1.7 1.7 0 0 1-.2.2.5.5 0 0 0 0 .7.5.5 0 0 0 .7 0 2 2 0 0 0 .5-2.5 1.7 1.7 0 0 0-1.2-.8c-.5-.1-1 .1-1.3.5a.5.5 0 1 0 .7.7Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m51.4 24.8.5 1v-.2.3l.2.2v-.3l.3-.3h.4v.1l.2.3v.2l-.3.4a.5.5 0 1 0-.3-1 .5.5 0 0 0-.4.3.5.5 0 0 0 .4.7.5.5 0 0 0 .7-.6 1.1 1.1 0 0 0-.1-.3l-.2-.3a5.5 5.5 0 0 0-.5-1 .5.5 0 0 0-.3-.2.5.5 0 0 0-.6.7Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m57.3 30.9 18.4 2.7a4 4 0 0 0 2 1.8c1.5.7 8 1.2 8 1.2a8.9 8.9 0 0 0 4.4-3.2l7.3 1.2s3.5-.7 5-4.2c1.5-3.4.7-6 0-6.6-.7-.7-3.4-2.5-3.4-2.5s-6.2-.3-7 0c-1 .3-2.1.3-2.8 1.6l-9-.8-8.8-.5s-1.8 1-2 2.2l-9.6-.2s-2.5.5-3.2 3.1c-.7 2.6.7 4.2.7 4.2Z",
        "fill": "#82C9E3"
      }
    }), h("path", {
      "attrs": {
        "d": "M82.7 32.2c-.4-1.5.1-4 .7-5 .5-1 2.4-2.1 3.6-1.5 1.2.7 2.2 2.2 1.9 4.3-.3 2.2-1.8 3.9-3.2 4-1.4.3-2.6-.4-3-1.8Zm14.2-.1c-1.6.1-2.4-1.6-2.2-3.6.1-2 1.3-5 3.7-4.9 2.5 0 2.6 3.6 2.4 4.9a4.2 4.2 0 0 1-4 3.6Z",
        "fill": "#C9ECF2"
      }
    }), h("path", {
      "attrs": {
        "d": "M74.8 19.6c5.7.3 11.3.9 17 1.1 1.2 0 1.2-1.7 0-1.8-5.7-.3-11.3-.8-17-1-1.2-.1-1.2 1.7 0 1.7Zm20-.2c2.2 0 4.4-.2 6.6 0 1.2.1 1.2-1.7 0-1.8-2.2-.3-4.4 0-6.7 0-1.2-.1-1.2 1.7 0 1.8ZM92 31.5l6.9 1.1c1.1.2 1.6-1.6.4-1.8l-6.9-1c-1.1-.2-1.6 1.5-.4 1.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M101.4 19.4c2.4.8 3.9 3.3 3.4 5.8-.5 2.6-2.2 5.5-5 5.7-1.2 0-1.2 2 0 1.8 3.8-.2 6.3-3.8 6.8-7.4a7 7 0 0 0-4.7-7.6c-1.1-.4-1.6 1.3-.5 1.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M101 19.9c-2.9-.1-4.1 3-4.5 5.3-.4 2.3.6 5.1 3.4 5 2.4-.1 4-2.6 4.5-4.8.4-2.4-.9-4.9-3.2-5.5-1.2-.3-1.7 1.5-.5 1.8 1.4.3 2.1 1.8 2 3.2-.3 1.3-1.1 3-2.5 3.4-2 .5-2.2-1.8-1.9-3.1.3-1.4 1-3.5 2.6-3.5 1.2 0 1.2-1.8 0-1.8Zm-6-2.3c-2 .2-3.3 1.3-4.3 3-.6 1 1 1.8 1.6.8.6-1 1.5-1.9 2.7-2 1.2-.1 1.2-2 0-1.8Zm-20.3.3c-1.6-.1-2.8 1-3.6 2.4-.6 1 1 1.9 1.6.9.4-.8 1-1.5 2-1.4.5 0 1-.5 1-1a1 1 0 0 0-1-.9Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M71.7 19.1a10 10 0 0 1-1.9 0 1 1 0 0 0-.9 1 1 1 0 0 0 1 .9 12.2 12.2 0 0 0 2.3-.1c.5 0 .8-.7.6-1.1-.1-.6-.6-.7-1-.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m62.7 21.6 17 1.1c1.2 0 1.2-1.8 0-1.8l-17-1.1c-1.2 0-1.2 1.8 0 1.8ZM60.4 29c5.8 1.1 11.6 2 17.4 2.8 1.1.2 1.6-1.6.5-1.8a428 428 0 0 1-17.4-2.7c-1.2-.2-1.7 1.5-.5 1.7Zm22.2-7.6c2.2.1 4.5-.2 6.7 0 1.2.2 1.2-1.6 0-1.8-2.2-.2-4.5.1-6.7 0-1.2 0-1.2 1.8 0 1.8Zm-3 12.2 7.3 1c1.1.3 1.6-1.5.4-1.7l-7.1-1.1c-1.2-.2-1.7 1.6-.5 1.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M89.3 21.4c2.4.8 3.9 3.2 3.4 5.8-.5 2.5-2.2 5.5-5 5.7-1.2 0-1.3 1.9 0 1.8 3.8-.3 6.3-3.8 6.8-7.4a7 7 0 0 0-4.7-7.7c-1.1-.3-1.6 1.4-.5 1.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M88.8 21.8c-2.8 0-4 3-4.5 5.4-.4 2.3.7 5.1 3.5 5 2.4-.1 4-2.6 4.5-4.8.4-2.4-.9-4.9-3.3-5.5-1-.3-1.6 1.4-.4 1.7 1.4.4 2.1 1.9 2 3.3-.3 1.3-1.1 3-2.5 3.4-2 .5-2.2-1.8-1.9-3.2.3-1.3 1-3.5 2.6-3.4 1.2 0 1.2-1.8 0-1.9Zm-6-2.3c-3 .4-4.7 3.1-5.4 5.9-.8 2.6-.5 6.5 2.2 8 1 .6 1.9-1 .9-1.5-1.9-1.2-1.9-4.2-1.4-6 .5-1.9 1.7-4.3 3.8-4.5 1.1-.2 1.2-2 0-1.9Zm-20.2.4c-4-.2-6.4 7-2.6 9 1 .5 2-1 .9-1.6-1.2-.7-1.2-2-.8-3.1.4-1.1 1.2-2.5 2.5-2.5 1.2.1 1.2-1.7 0-1.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M59.6 21.1a9.8 9.8 0 0 1-1.9 0 1 1 0 0 0-.9 1 1 1 0 0 0 1 .9 12.2 12.2 0 0 0 2.3-.1c.5-.1.8-.7.6-1.2-.1-.5-.6-.7-1-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M56.6 21.7a6.7 6.7 0 0 0-1 4c0 1.1 1.9 1.1 1.8 0a5 5 0 0 1 .8-3.1c.6-1-1-1.9-1.6-1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M56.4 26.8a12.9 12.9 0 0 0 2.5.7A1 1 0 0 0 60 27c.1-.5-.1-1-.6-1.1a12.8 12.8 0 0 1-2.6-.8c-.4-.1-1 .2-1 .7-.2.5.1.9.6 1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M57.5 22.3c-.5 1-1.2 2.2-1 3.4.3 1.2 2 .7 1.8-.5l.3-1a8.3 8.3 0 0 1 .5-1c.6-1-1-2-1.6-1Zm31 5.6c.9 0 .9-1.4 0-1.4s-1 1.4 0 1.4Zm11.3-2.8a.5.5 0 0 0 0 .3.5.5 0 0 0 .2.3.8.8 0 0 0 .5.2h.2a.7.7 0 0 0 .3-.2l.1-.2a.7.7 0 0 0 .1-.3V25a.8.8 0 0 0-.2-.5.8.8 0 0 0-.5-.2h-.2a.7.7 0 0 0-.3.2v.1a.7.7 0 0 0-.2.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M36 25c-1.2 2.7 0 5.7 2.5 7.3 2.6 1.7 6.2 1.9 9.3 1.7a25.8 25.8 0 0 0 9.2-2.3c3.1-1.4 5.5-3.6 8.3-5.7 1-.9 0-2.8-1.2-2-2.2 1.8-4.2 3.7-6.6 5a23.2 23.2 0 0 1-7.7 2.6c-2.6.4-5.4.4-8-.3-2-.6-5-2.6-3.9-5.2.6-1.3-1.3-2.4-1.9-1.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M66 24.4c-.2-.8-.1-2.3 1-2.5.6 0 .9-.8.7-1.3-.1-.7-.7-.9-1.3-.8-2.4.3-3 3.3-2.4 5.2.4 1.4 2.5.8 2-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M66.8 25.8a22.4 22.4 0 0 1 2.8-2.7c.2-.2.1-.2-.3-.2 1.2.7 2.3-1.2 1.1-1.9-1-.6-2 .1-2.7.8a22.4 22.4 0 0 0-2.5 2.4c-.9 1 .7 2.6 1.6 1.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M66 26.2a30 30 0 0 1 4.2-.1c1.4 0 1.4-2.2 0-2.2a30 30 0 0 0-4.2 0c-1.4.2-1.4 2.4 0 2.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m91.2 49.2-.7 4.2c-.2 1.2 1.7 1.8 2 .5l.7-4.1c.2-1.3-1.7-1.8-2-.6Zm13.8-4.5a71.2 71.2 0 0 0 2.1 5.8c.5 1.2 2.4.7 2-.5a73.4 73.4 0 0 1-2.1-5.8c-.4-1.3-2.3-.7-2 .5Zm12-7.5 4 2.4c1.2.6 2.2-1 1-1.7l-4-2.4c-1.2-.6-2.2 1.1-1 1.7Zm-.5-26a85.2 85.2 0 0 0 4.6-6.4c.7-1.1-1-2.1-1.7-1-1.4 2-2.8 4-4.4 6-.7 1 .7 2.4 1.5 1.4Zm-12.8-8.5a25.3 25.3 0 0 1-.6 3.3c-.3 1.2 1.7 1.8 2 .5.3-1.2.5-2.5.6-3.8 0-.5-.5-1-1-1-.6 0-1 .5-1 1ZM88.2 5.5l.7 2.8c.3 1.2 2.3.7 2-.5L90.1 5c-.4-1.3-2.3-.7-2 .5Z",
        "fill": "#FF8000"
      }
    })]);
  }
};

export { BagBinocularsBgIcon as default };
